module.exports = "<app-menu-top></app-menu-top>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main